import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SMSService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  //SMS SETTING------------------------------------------------------------------

  GetSettings(): Observable<any> {   
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetSettings', { headers: reqHeader });
  }

  SaveSettings(objSettings): Observable<any> {

    let formData = new FormData();
    formData.append("objSettings", objSettings);
 

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SaveSettings', formData);
    
  }

  //SMS TEMPLATE------------------------------------------------------------------

  GetTemplate(): Observable<any> {   
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetTemplate', { headers: reqHeader });
  }

  SaveTemplate(strdata): Observable<any> {
    var param = 'objTemplate=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/SaveTemplate?' + encodeURI(param), { headers: reqHeader });
  }
  TemplateMarkActive(strdata): Observable<any> {
    var param = 'objTemplate=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/SaveTemplate?' + encodeURI(param), { headers: reqHeader });
  }

   //SMS GROUP------------------------------------------------------------------

   GetGroup(): Observable<any> {   
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetGroup', { headers: reqHeader });
  }

  SaveGroup(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/SaveGroup?' + encodeURI(param), { headers: reqHeader });
  }

  GroupMarkActive(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GroupMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  GetGroupContactDetails(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetGroupContactDetails?' + encodeURI(param), { headers: reqHeader });
  }

  GetGroupContact(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetGroupContact?' + encodeURI(param), { headers: reqHeader });
  }

   //SMS CONTACT------------------------------------------------------------------

  
   SaveGroupContact(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/SaveGroupContact?' + encodeURI(param), { headers: reqHeader });
  }

  ContactMarkActive(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/ContactMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  SaveContact(data: any, File: any): Observable<any> {

    let formData = new FormData();
    formData.append("data", data);
    formData.append("file", File);  

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SaveContact', formData);
  }
  

  DeleteContact(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/DeleteContact?' + encodeURI(param), { headers: reqHeader });
  }

  SaveContactCommaSeperated(GroupID, data): Observable<any> {

    let formData = new FormData();
    formData.append("GroupID", GroupID);
    formData.append("objList", data);  
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SaveContactCommaSeperated', formData);
  }
 

  //SMS FEE DUE ALERT------------------------------------------------------------------  

  SMS_GetFeeDueAlert(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/SMS_GetFeeDueAlert?' + encodeURI(param), { headers: reqHeader });
  }


  SendFeeDueAlert(data,PersonTypeID, MessageType,SendTypeID): Observable<any> {

    let formData = new FormData();
    formData.append("PersonTypeID", PersonTypeID);
    formData.append("objList", data);  
    formData.append("MessageType", MessageType); 
    formData.append("SendTypeID", SendTypeID);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SendFeeDueAlert', formData);
  }
 

  //SMS EMERGENCY MESSAGE------------------------------------------------------------------  

  GetStudentDetails(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetStudentForEmergency?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffDetails(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetStaffforEmergency?' + encodeURI(param), { headers: reqHeader });
  }

  SaveChatFile(file): Observable<any> {

    let formData = new FormData();    
    for (var i = 0; i < file.length; i++) {
      formData.append("AlbumPhoto" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.MobileApiUrl + 'mChat/SaveChatFile', formData);
  }
  SendEmergencyMessage(data, PersonTypeID, Message, MessageType, IsFirstName,SendTypeID,file,DLTTemplateID): Observable<any> {

    let formData = new FormData();
    formData.append("objList", data);
    formData.append("PersonTypeID", PersonTypeID);
    formData.append("Message", Message);
    formData.append("MessageType", MessageType);
    formData.append("DLTTemplateID", DLTTemplateID);
    formData.append("IsFirstName", IsFirstName);
    formData.append("SendTypeID", SendTypeID);
    formData.append("FileList", file);
    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SendEmergencyMessage', formData);
  }
  
  GetEmergencyGroupDetails(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetEmergencyGroupDetails?' + encodeURI(param), { headers: reqHeader });
  }

   //SMS MARKS ALERT------------------------------------------------------------------  

  
  UploadStudent(data: any): Observable<any> {

    let formData = new FormData();
    formData.append("StudentData", data);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/StudentUpload', formData);
  }

  UploadGroupContact(strdata): Observable<any> {
    let formData = new FormData();
    formData.append("GroupData", strdata);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/UploadGroupContact', formData);
  }


  SendMarkAlert(data, MessageType): Observable<any> {

    let formData = new FormData();
    formData.append("objList", data);  
    formData.append("MessageType", MessageType);  
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SendMarkAlert', formData);
  }

  //SMS BIRTH DAY ALERT------------------------------------------------------------------  

  GetStudentforBithdayAlert(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetStudentforBithdayAlert?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffforBirthdayAlert(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetStaffforBirthdayAlert?' + encodeURI(param), { headers: reqHeader });
  }

  GetBirtdayGroupDetails(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SMS/GetBirtdayGroupDetails?' + encodeURI(param), { headers: reqHeader });
  }

   SendBirthdayAlert(data, strSMS,file): Observable<any> {

    let formData = new FormData();
    formData.append("objList", data);
    formData.append("strSMS", strSMS);
    for (var i = 0; i < file.length; i++) {
      formData.append("AlbumPhoto" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SendBirthdayAlert', formData);
  }

}